/*
 * Eclipse — Newsletter post-submit scroll restore
 *
 * Why: Shopify's `{% form 'customer' %}` POSTs to /contact and 302-redirects
 * back to the source page with `?customer_posted=true#hdt-form-newsletter-XXX`.
 * The native form submit DOES create the customer correctly (verified by Sam),
 * but on reload the page lands at scrollY=0 instead of scrolling to the form
 * hash. Two reasons:
 *   1. The footer form may not be in the DOM yet when the browser tries to
 *      honor the hash scroll, so the anchor jump silently fails.
 *   2. snippets/smooth-scroll.liquid (cf. CLAUDE.md piège) initializes its
 *      targetScroll/currentScroll from window.scrollY at DOMContentLoaded.
 *      If the browser landed at 0, the virtual scroll engine is pinned at 0
 *      and stays there.
 *
 * Fix: keep the native submit (it works), and on load — when we detect a
 * `customer_posted=true` return — find the submitted form and scroll it into
 * view. The smooth-scroll snippet's own `scroll` listener (lines 33-40) will
 * detect the divergence > 2px and resync, so the user can wheel away
 * naturally afterwards.
 *
 * AJAX attempts (v1 → v3, commits 542221f, a8ff0d0, 66c4126) all failed to
 * create the customer reliably — Shopify's /contact endpoint appears to drop
 * customer creation when the POST isn't a real navigate-mode browser submit
 * (likely bot detection). Native submit is the source of truth here.
 */
(function () {
  'use strict';

  function findPostedForm() {
    // Kalles' custom.js (line 570) adds .on-live to the form that was just
    // submitted, by reading the form id back from sessionStorage. That's our
    // most reliable handle — and it works even when the URL hash got stripped
    // by Cloudflare or a redirect chain.
    var live = document.querySelector('.hdt-newsletter__form.on-live');
    if (live) return live;

    // Fallback: try the URL hash (#hdt-form-newsletter-XXX) if present.
    if (location.hash && location.hash.length > 1) {
      try {
        return document.querySelector(location.hash);
      } catch (e) {
        return null;
      }
    }

    // Last-ditch fallback: the first newsletter form on the page (usually the
    // footer one, which is the only one merchants typically expose).
    return document.querySelector('.hdt-newsletter__form');
  }

  function scrollFormIntoView(form) {
    if (!form) return;
    var rect = form.getBoundingClientRect();
    var targetY = rect.top + window.scrollY - Math.max(0, (window.innerHeight - rect.height) / 2);
    targetY = Math.max(0, targetY);
    // Use native scrollTo (not scrollIntoView with smooth) so smooth-scroll's
    // own `scroll` listener fires with the new scrollY in a single tick and
    // resyncs its targetScroll/currentScroll cleanly.
    window.scrollTo(0, targetY);
  }

  function handlePostedReturn() {
    if (location.search.indexOf('customer_posted=true') === -1) return;

    // Wait two animation frames: frame 1 lets smooth-scroll.liquid run its
    // init() (which clamps targetScroll/currentScroll to whatever scrollY
    // currently is — usually 0), frame 2 is our turn to scroll to the form.
    // smooth-scroll's `scroll` listener (line 33-40) then catches our scroll
    // event, sees real != currentScroll by > 2px, and resyncs both values.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var form = findPostedForm();
        scrollFormIntoView(form);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handlePostedReturn);
  } else {
    handlePostedReturn();
  }
})();
